import { Fetch, FetchAttachment } from '../Models/shared/general';

//#region ======== ACTIONS ========
const actions = {
    //======== Payments MANAGEMENT ======
    payment_new_create              : "payment_new_create",
    payment_load_bydate             : "payment_load_bydate",
    paymentacct_load_all            : "paymentacct_load_all",
    payee_load_active               : "payee_load_active",
    payee_load_all                  : "payee_load_all",
    paytype_load_all                : "paytype_load_all",
    acctitems_load_all              : "acctitems_load_all",
    payment_update_byid             : "payment_update_byid",
    paymenttemplate_new_create      : "paymenttemplate_new_create",
    paymenttemplate_load_byuserid   : "paymenttemplate_load_byuserid",
    paymenttemplate_update_byid     : "paymenttemplate_update_byid",
    payment_create_bytemplate       : "payment_create_bytemplate",
    payee_update_byid               : "payee_update_byid",
    paymentacct_update_byid         : "paymentacct_update_byid",
    acctitems_update_byid           : "acctitems_update_byid",
    payment_load_bypayee            : "payment_load_bypayee"

};
//#endregion

//#region ========== API FUNCTIONS ===========
export async function payment_new_create(data){
    return Fetch({ action: actions.payment_new_create, data: data });
}

export async function paymenttemplate_new_create(data){
    return Fetch({ action: actions.paymenttemplate_new_create, data: data });
}

export async function payment_create_bytemplate(data,invdate){
    return Fetch({ action: actions.payment_create_bytemplate, data: [data,invdate] });
}

export async function paymenttemplate_load_byuserid(data){
    return Fetch({ action: actions.paymenttemplate_load_byuserid, data: data });
}

export async function payment_load_bydate(data){
    return Fetch({ action: actions.payment_load_bydate, data: data });
}

export async function payment_load_bypayee(data){
    return Fetch({ action: actions.payment_load_bypayee, data: data });
}

export async function paymentacct_load_all(data){
    return Fetch({ action: actions.paymentacct_load_all, data: data });
}

export async function payee_load_active(data){
    return Fetch({ action: actions.payee_load_active, data: data });
}

export async function payee_load_all(data){
    return Fetch({ action: actions.payee_load_all, data: data });
}

export async function paytype_load_all(data){
    return Fetch({ action: actions.paytype_load_all, data: data });
}

export async function acctitems_load_all(data){
    return Fetch({ action: actions.acctitems_load_all, data: data });
}

export async function acctitems_update_byid(data){
    return Fetch({ action: actions.acctitems_update_byid, data: data });
}

export async function payment_update_byid(data){
    return Fetch({ action : actions.payment_update_byid, data: data})
}

export async function paymentacct_update_byid(data){
    return Fetch({ action : actions.paymentacct_update_byid, data: data})
}

export async function paymenttemplate_update_byid(data){
    return Fetch({ action : actions.paymenttemplate_update_byid, data: data})
}

export async function payee_update_byid(data){
    return Fetch({ action : actions.payee_update_byid, data: data})
}